// ─────────────────────────────────────────────────────────
// Добавьте в ваш Vuex store:
//
// state:   investorFlipProjects: [ ...проекты... ]
// getter:  getInvestorFlipProjects: state => state.investorFlipProjects
// ─────────────────────────────────────────────────────────

const investorFlipProjects = [
	{
		// ── ИДЕНТИФИКАТОР (используется в URL) ──────────────
		slug: 'kilcullen-charlotte-2026',

		// ── КАРТОЧКА (список проектов) ───────────────────────
		coverImage: '/flip/kilcullen/after-exterior-01.jpg', // главное фото карточки
		year: '2026',
		location: 'South Charlotte, NC',
		title: 'South Charlotte Full Home Flip',
		subtitle: 'Interior & Exterior Transformation',
		shortDesc: 'Beautifully renovated 4-bed/3-bath home on a quiet cul-de-sac — kitchen, bathrooms, flooring, two new decks, and more.',
		description: 'Beautifully and meticulously renovated 4-bedroom, 3-bathroom home tucked away on a quiet cul-de-sac in desirable South Charlotte — within walking distance of the 19-mile Little Sugar Creek Greenway. New flooring throughout, fresh paint, renovated bathrooms, recessed lighting, and a stunning remodeled kitchen with Taj Mahal Quartz countertops, white cabinetry, and brass hardware.',

		// ── СТАТИСТИКА ───────────────────────────────────────
		stats: [
			{ value: '+$260K', label: 'Est. Value Added' },
			{ value: '8 wks', label: 'Project Duration' },
			{ value: '4 / 3', label: 'Beds / Baths' },
		],

		// ── SCOPE OF WORK ────────────────────────────────────
		scope: [
			{ title: 'Kitchen Remodel', text: 'Taj Mahal Quartz countertops, white cabinetry, brass hardware, all-new stainless steel appliances, warm designer tones.' },
			{ title: 'Bathroom Renovation', text: 'Three bathrooms fully renovated — tile, vanity, fixtures, and lighting.' },
			{ title: 'New Flooring Throughout', text: 'New flooring installed on every level of the home.' },
			{ title: 'Fresh Paint', text: 'Full interior repaint with modern, move-in-ready color palette.' },
			{ title: 'Two Brand New Decks', text: 'One deck on the side of the home, another overlooking the fully fenced backyard — perfect for entertaining.' },
			{ title: 'Lighting & Electrical', text: 'New recessed lighting with dimming switches throughout the entire home.' },
		],

		// ── ФОТО ДО ──────────────────────────────────────────
		// Добавляйте/удаляйте объекты — компонент покажет сначала 4,
		// остальные — по кнопке "Show more"
		photosBefore: [
			{ src: '/flip/kilcullen/before-kitchen-01.jpg', alt: 'Kitchen before remodel', caption: 'Kitchen — before' },
			{ src: '/flip/kilcullen/before-living-01.jpg', alt: 'Living room before remodel', caption: 'Living room — before' },
			{ src: '/flip/kilcullen/before-bath-01.jpg', alt: 'Bathroom before remodel', caption: 'Bathroom — before' },
			{ src: '/flip/kilcullen/before-bed-01.jpg', alt: 'Bedroom before remodel', caption: 'Bedroom — before' },
			{ src: '/flip/kilcullen/before-exterior-01.jpg', alt: 'Exterior before remodel', caption: 'Exterior — before' },
			// + ещё фото...
		],

		// ── ФОТО ПОСЛЕ (готовый проект) ──────────────────────
		photosAfter: [
			{ src: '/flip/kilcullen/after-kitchen-01.jpg', alt: 'Kitchen after remodel', caption: 'Kitchen — finished' },
			{ src: '/flip/kilcullen/after-kitchen-02.jpg', alt: 'Kitchen after remodel', caption: 'Kitchen — finished' },
			{ src: '/flip/kilcullen/after-living-01.jpg', alt: 'Living room after remodel', caption: 'Living room — finished' },
			{ src: '/flip/kilcullen/after-living-02.jpg', alt: 'Living room after remodel', caption: 'Living room — finished' },
			{ src: '/flip/kilcullen/after-living-03.jpg', alt: 'Living room after remodel', caption: 'Living room — finished' },
			{ src: '/flip/kilcullen/after-living-04.jpg', alt: 'Living room after remodel', caption: 'Living room — finished' },
			{ src: '/flip/kilcullen/after-bath-01.jpg', alt: 'Bathroom after remodel', caption: 'Bathroom — finished' },
			{ src: '/flip/kilcullen/after-bath-02.jpg', alt: 'Bathroom after remodel', caption: 'Bathroom — finished' },
			{ src: '/flip/kilcullen/after-bath-03.jpg', alt: 'Bathroom after remodel', caption: 'Bathroom — finished' },
			{ src: '/flip/kilcullen/after-bed-01.jpg', alt: 'Bedroom after remodel', caption: 'Bedroom — finished' },
			{ src: '/flip/kilcullen/after-bed-02.jpg', alt: 'Bedroom after remodel', caption: 'Bedroom — finished' },
			{ src: '/flip/kilcullen/after-exterior-01.jpg', alt: 'Exterior after remodel', caption: 'Exterior — finished' },
			{ src: '/flip/kilcullen/after-exterior-02.jpg', alt: 'Exterior after remodel', caption: 'Exterior — finished' },
			{ src: '/flip/kilcullen/after-exterior-03.jpg', alt: 'Exterior after remodel', caption: 'Exterior — finished' },
			{ src: '/flip/kilcullen/after-exterior-04.jpg', alt: 'Exterior after remodel', caption: 'Exterior — finished' },
			{ src: '/flip/kilcullen/after-exterior-05.jpg', alt: 'Exterior after remodel', caption: 'Exterior — finished' },
			// + ещё фото...
		],

		// ── ВИДЕО ────────────────────────────────────────────
		// Для каждого видео вставьте только ID из YouTube Shorts:
		// https://youtube.com/shorts/XXXXXXXXXXX  →  id: 'XXXXXXXXXXX'
		videos: {
			// Видео "До и после" — показываются первыми, все сразу
			beforeAfter: [
				{ id: 'A5BPx7waQiU', title: 'Before & After — Exterior & Curb Appeal' },
				{ id: 'H3vWVsCmeX8', title: 'Before & After — Interior Transformation' },
				// + ещё видео...
			],

			// Видео "Процесс работы" — первые 3 видны, остальные по кнопке
			process: [
				{ id: 'UNkQJg-lDXM', title: 'First day of the project' },
				{ id: 'FdqaIcvlOQc', title: 'Midway through the second week of the work process' },
				{ id: '8JCsrgUXW_E', title: 'Removing Floors, Tile & Kitchen' },
				{ id: 'mSu9zTSyJiE', title: 'The process of external transformation of the house' },
				// + ещё видео...
			],

			// Видео готового проекта — показываются все сразу
			finished: [
				{ id: 'kz4-cBaCEy4', title: 'Final Walkthrough — Hillside Charlotte' },
				// + ещё видео...
			],
		},
	},

	// ════════════════════════════════════════════════════════
	// ВТОРОЙ ПРОЕКТ — просто скопируйте блок выше и заполните
	// ════════════════════════════════════════════════════════
	// {
	//   slug: 'maple-street-2025',
	//   coverImage: '/flip/maple/after-main.jpg',
	//   ...
	// },
]

export default investorFlipProjects